// frontend/src/features/livestock/cropOutput.ts
// What a server-side crop of an inbox photo produces (plan 4.4): the timeline
// variants are made from the crop of the master, the largest 1920 px; the
// feed shows the 800 px one, so a crop smaller than that is marked low.

/** A crop as fractions (0 to 1) of the image's width and height. */
export interface CropFractions {
  x: number;
  y: number;
  w: number;
  h: number;
}

/** The largest variant made from a crop (timeline `full`). */
const OUTPUT_MAX = 1920;
/** The `display` variant: a crop smaller than this is upscaled in the feed. */
const OUTPUT_TARGET = 800;
/** The server's smallest crop side, in the original's pixels. */
const MIN_SIDE = 32;

export interface CropOutput {
  /** "1240 px", "640 px · low", or "Too small to crop". */
  label: string;
  low: boolean;
  tooSmall: boolean;
}

export function cropOutput(
  crop: CropFractions,
  source: { width: number; height: number }
): CropOutput {
  const width = crop.w * source.width;
  const height = crop.h * source.height;
  if (Math.min(width, height) < MIN_SIDE) {
    return { label: 'Too small to crop', low: true, tooSmall: true };
  }
  const longEdge = Math.max(width, height);
  const low = longEdge < OUTPUT_TARGET;
  const px = Math.round(Math.min(OUTPUT_MAX, longEdge));
  return { label: `${px} px${low ? ' · low' : ''}`, low, tooSmall: false };
}
